import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/apply/',
  name: 'apply',
  meta: {
    auth: true
  },
  redirect: {
    name: 'apply-index'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'news-delay/update',
      name: `${pre}news-delay/update`,
      component: _import('apply/news-delay/update'),
      meta: {
        title: '新申请'
      }
    },
    {
      path: 'news-delay/list',
      name: `${pre}news-delay/list`,
      component: _import('apply/news-delay/index'),
      meta: {
        title: '申请列表'
      }
    },
    {
      path: 'news-delay/review',
      name: `${pre}news-delay/review`,
      component: _import('apply/news-delay/review'),
      meta: {
        title: '申请审批'
      }
    },
    {
      path: 'news-update/update',
      name: `${pre}news-update/update`,
      component: _import('apply/news-update/update'),
      meta: {
        title: '新申请'
      }
    },
    {
      path: 'news-update/list',
      name: `${pre}news-update/list`,
      component: _import('apply/news-update/index'),
      meta: {
        title: '申请列表'
      }
    },
    {
      path: 'news-update/review',
      name: `${pre}news-update/review`,
      component: _import('apply/news-update/review'),
      meta: {
        title: '申请审批'
      }
    },
    {
      path: 'poster-banner/update',
      name: `${pre}poster-banner/update`,
      component: _import('apply/poster-banner/update'),
      meta: {
        title: '新申请'
      }
    },
    {
      path: 'poster-banner/list',
      name: `${pre}poster-banner/list`,
      component: _import('apply/poster-banner/index'),
      meta: {
        title: '申请列表'
      }
    },
    {
      path: 'poster-banner/review',
      name: `${pre}poster-banner/review`,
      component: _import('apply/poster-banner/review'),
      meta: {
        title: '申请审批'
      }
    },
    {
      path: 'bigscreen/update',
      name: `${pre}bigscreen/update`,
      component: _import('apply/bigscreen/update'),
      meta: {
        title: '新申请'
      }
    },
    {
      path: 'bigscreen/list',
      name: `${pre}bigscreen/list`,
      component: _import('apply/bigscreen/index'),
      meta: {
        title: '申请列表'
      }
    },
    {
      path: 'bigscreen/review',
      name: `${pre}bigscreen/review`,
      component: _import('apply/bigscreen/review'),
      meta: {
        title: '申请审批'
      }
    }
  ])('apply-')
}
